export enum LVED_LINKS {
  termsOfService = 'http://www.lved.com/affiliateTerms',
  termsOfServiceText = 'https://www.lved.com/termsdocs/affiliateTerms.txt',
}
